export enum ProviderQuestionAnswers {
  Yes = 'Yes',
  No = 'No',
}
